(function () {
  'use strict';

  if (window.SproosRelatedProductsSwitcher) return;

  var state = {
    controller: null,
    cache: new Map(),
    requestId: 0
  };

  function canonicalProductUrl(url) {
    var parsed = new URL(url, window.location.origin);
    parsed.hash = '';
    parsed.searchParams.delete('view');
    return parsed;
  }

  function childRenderUrl(url) {
    var parsed = canonicalProductUrl(url);
    return parsed.href;
  }

  function getProductSection(root) {
    return (root || document).querySelector('[data-section-type="product"][data-product-handle]');
  }

  function getSectionWrapper(section) {
    if (!section) return null;
    return section.closest('.shopify-section') || section;
  }

  function productHandleFromUrl(url) {
    var parsed = canonicalProductUrl(url);
    var parts = parsed.pathname.split('/').filter(Boolean);
    var productIndex = parts.indexOf('products');
    return productIndex > -1 ? parts[productIndex + 1] || '' : '';
  }

  function unloadThemeSection(container) {
    var sections = window.Shopify && window.Shopify.theme && window.Shopify.theme.sections;
    var instances = sections && sections.instances;
    if (!instances || !container) return;

    for (var i = instances.length - 1; i >= 0; i -= 1) {
      var instance = instances[i];
      if (instance.container === container) {
        try {
          if (typeof instance.onUnload === 'function') instance.onUnload();
        } catch (error) {
          console.warn('Related product switcher: section unload failed', error);
        }
        instances.splice(i, 1);
      }
    }
  }

  function loadThemeSection(container) {
    var sections = window.Shopify && window.Shopify.theme && window.Shopify.theme.sections;
    var registered = sections && sections.registered;
    var instances = sections && sections.instances;
    if (!registered || !instances || !container) return;

    var type = container.getAttribute('data-section-type');
    var id = container.getAttribute('data-section-id');
    var registration = registered[type];
    if (!type || !id || !registration) return;

    var callStack = typeof registration.getStack === 'function' ? registration.getStack() : registration.callStack;
    if (!callStack) return;

    var instance = {
      container: container,
      id: id,
      type: type,
      callStack: callStack,
      callFunctions: function (key, event) {
        var callbacks = this.callStack[key] || [];
        var props = { id: this.id, type: this.type, container: this.container };
        callbacks.forEach(function (callback) {
          if (event) callback.call(props, event);
          else callback.call(props);
        });
      },
      onLoad: function () { this.callFunctions('onLoad'); },
      onUnload: function () { this.callFunctions('onUnload'); },
      onSelect: function (event) { this.callFunctions('onSelect', event); },
      onDeselect: function (event) { this.callFunctions('onDeselect', event); },
      onBlockSelect: function (event) { this.callFunctions('onBlockSelect', event); },
      onBlockDeselect: function (event) { this.callFunctions('onBlockDeselect', event); },
      onReorder: function (event) { this.callFunctions('onReorder', event); }
    };

    instances.push(instance);
    try {
      instance.onLoad();
    } catch (error) {
      console.warn('Related product switcher: section load failed', error);
    }
  }

  function activateScripts(container) {
    if (!container) return;

    container.querySelectorAll('script').forEach(function (oldScript) {
      var type = (oldScript.getAttribute('type') || '').toLowerCase();
      if (type && type !== 'text/javascript' && type !== 'application/javascript' && type !== 'module') return;

      var newScript = document.createElement('script');
      Array.prototype.slice.call(oldScript.attributes).forEach(function (attribute) {
        newScript.setAttribute(attribute.name, attribute.value);
      });
      if (oldScript.textContent) newScript.textContent = oldScript.textContent;
      oldScript.replaceWith(newScript);
    });
  }

  function updateDocumentMetadata(doc, displayUrl, options) {
    var settings = options || {};

    if (settings.updateMetadata !== false) {
      if (doc.title) document.title = doc.title;

      var destinationCanonical = doc.querySelector('link[rel="canonical"]');
      var currentCanonical = document.querySelector('link[rel="canonical"]');
      if (destinationCanonical && currentCanonical) currentCanonical.href = destinationCanonical.href;

      var destinationDescription = doc.querySelector('meta[name="description"]');
      var currentDescription = document.querySelector('meta[name="description"]');
      if (destinationDescription && currentDescription) {
        currentDescription.setAttribute('content', destinationDescription.getAttribute('content') || '');
      }
    }

    if (settings.updateHistory !== false) {
      window.history.replaceState({ sproosRelatedProduct: true }, '', displayUrl.pathname + displayUrl.search);
    }
  }

  function setLoading(isLoading) {
    var section = getProductSection();
    if (!section) return;
    section.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    section.classList.toggle('is-related-product-loading', isLoading);
  }


  function selectDefaultSubscription(root) {
    var picker = (root || document).querySelector('skio-plan-picker');
    if (!picker) return;

    var attempts = 0;
    var maxAttempts = 40;

    function trySelectSubscription() {
      attempts += 1;

      var options = picker.options;
      if (!options) {
        if (attempts < maxAttempts) window.setTimeout(trySelectSubscription, 50);
        return;
      }

      var startsOnetime = options.start_onetime === true || options.start_onetime === 'true';
      if (startsOnetime || picker.selectedSellingPlan) return;

      var groups = picker.availableSellingPlanGroups;
      if (groups && groups.length && typeof picker.selectSellingPlan === 'function') {
        var selectedGroup = groups.find(function (group) {
          return group.selected && group.selected_selling_plan;
        }) || groups[0];
        var selectedPlan = selectedGroup.selected_selling_plan || (selectedGroup.selling_plans && selectedGroup.selling_plans[0]);

        if (selectedPlan) {
          picker.variantChanged = false;
          picker.selectSellingPlan(selectedPlan.id);
          return;
        }
      }

      if (attempts < maxAttempts) window.setTimeout(trySelectSubscription, 50);
    }

    function startSelection() {
      if (picker.updateComplete && typeof picker.updateComplete.then === 'function') {
        picker.updateComplete.then(trySelectSubscription);
      } else {
        trySelectSubscription();
      }
    }

    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      window.customElements.whenDefined(picker.localName).then(startSelection);
    } else {
      startSelection();
    }
  }

  function fetchProductPage(url, signal) {
    if (state.cache.has(url)) return Promise.resolve(state.cache.get(url));

    return fetch(url, {
      credentials: 'same-origin',
      signal: signal,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Product request failed: ' + response.status);
        return response.text();
      })
      .then(function (html) {
        state.cache.set(url, html);
        return html;
      });
  }

  function switchProduct(url, options) {
    var settings = options || {};
    var displayUrl = canonicalProductUrl(url);
    var fetchUrl = childRenderUrl(url);
    var expectedHandle = productHandleFromUrl(displayUrl);
    var currentProductSection = getProductSection();
    var currentWrapper = getSectionWrapper(currentProductSection);
    if (!currentProductSection || !currentWrapper || !expectedHandle) return Promise.resolve(false);

    if (!settings.force && currentProductSection.getAttribute('data-product-handle') === expectedHandle) {
      return Promise.resolve(true);
    }

    var requestId = ++state.requestId;
    if (state.controller) state.controller.abort();
    state.controller = new AbortController();
    setLoading(true);

    return fetchProductPage(fetchUrl, state.controller.signal)
      .then(function (html) {
        if (requestId !== state.requestId) return false;

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextProductSection = getProductSection(doc);
        var nextWrapper = getSectionWrapper(nextProductSection);
        if (!nextProductSection || !nextWrapper) throw new Error('Product section not found in child response');

        var returnedHandle = nextProductSection.getAttribute('data-product-handle');
        if (returnedHandle !== expectedHandle) {
          throw new Error('Child response handle mismatch: expected ' + expectedHandle + ', got ' + returnedHandle);
        }

        unloadThemeSection(currentProductSection);

        var importedWrapper = document.importNode(nextWrapper, true);
        currentWrapper.replaceWith(importedWrapper);

        var importedProductSection = getProductSection(importedWrapper);
        activateScripts(importedWrapper);
        loadThemeSection(importedProductSection);
        updateDocumentMetadata(doc, displayUrl, settings);
        selectDefaultSubscription(importedWrapper);

        document.dispatchEvent(new CustomEvent('sproos:related-product:change', {
          detail: { url: displayUrl.href, handle: expectedHandle }
        }));

        return true;
      })
      .catch(function (error) {
        if (error && error.name !== 'AbortError') console.error('Related product switcher:', error);
        return false;
      })
      .finally(function () {
        if (requestId === state.requestId) setLoading(false);
      });
  }

  function handleColorClick(event) {
    var link = event.target.closest('[data-related-products-switcher] a.sibling__link');
    if (!link) return;
    if (link.target === '_blank') return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;

    event.preventDefault();
    if (link.classList.contains('sibling__link--current')) return;
    switchProduct(link.href);
  }

  function init() {
    document.addEventListener('click', handleColorClick);

    var parentSwitcher = document.querySelector('[data-related-products-parent]');
    if (!parentSwitcher) return;

    // Child already preselected server-side: still ensure Skio picks a plan + updates ?selling_plan=
    if (parentSwitcher.hasAttribute('data-related-products-parent-ready')) {
      selectDefaultSubscription(document);
      return;
    }

    var initialChildLink = parentSwitcher.querySelector('a.sibling__link--current');
    if (!initialChildLink) {
      initialChildLink = parentSwitcher.querySelector('a.sibling__link:not(.sibling__link--sold-out)');
    }
    if (!initialChildLink) {
      initialChildLink = parentSwitcher.querySelector('a.sibling__link');
    }

    if (initialChildLink) {
      switchProduct(initialChildLink.href, {
        force: true,
        updateHistory: false,
        updateMetadata: false
      });
    }
  }

  window.SproosRelatedProductsSwitcher = {
    switchProduct: switchProduct
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
